/** SAT recipient stored at businesses/{businessId}/invoicingRecipients/{rfc}. */
export interface InvoicingRecipient {
  rfc: string;
  name: string;
  fiscalRegime: string;
  /** Código postal del domicilio fiscal. Empty when the constancia did not include one. */
  postalCode: string;
  cfdiUse: string;
  /** Expediente this RFC is kept in sync with. Absent when the recipient stands alone. */
  patientId?: string;
  /** Name of that expediente, shown in the list. */
  patientName?: string;
}

export const RECIPIENT_RFC_RE = /^[A-ZÑ&]{3,4}\d{6}[A-Z0-9]{3}$/;

export function normalizeRecipientRfc(value: string): string {
  return value.toUpperCase().replace(/[^A-ZÑ&0-9]/g, '').slice(0, 13);
}
